import { modalRoute } from '@/router/helpers/modalRoute'

export const homeRoutes = [
  {
    path: 'home',
    name: 'Home',
    component: () => import('@/components/home/Index.vue'),
    children: [
      modalRoute(
        'send/to-card',
        'Home:SendToCard',
        () =>
          import('@/components/wallets/modals/transfer-to-card/SendToCard.vue'),
        {
          meta: {
            permissions: ['transferToCardCreate'],
          },
        },
      ),
      modalRoute(
        'bulk-drafts',
        'Home:BulkDrafts',
        () => import('@/components/bulk-drafts/BulkDraftsModal.vue'),
      ),
      modalRoute(
        'payment/:paymentId/repeat',
        'Home:TransferRepeat',
        () => import('@/components/wallets/modals/transfer/Transfer.vue'),
      ),
      modalRoute(
        'payment/:paymentId/delete',
        'Home:PaymentDetails:DraftDelete',
        () =>
          import(
            '@/components/wallets/view/parts/history/modals/drafts/DraftDeleteModal.vue'
          ),
      ),
      modalRoute(
        'payment/:paymentId',
        'Home:PaymentDetails',
        () =>
          import(
            '@/components/wallets/view/parts/history/modals/details/HistoryItemDetails.vue'
          ),
      ),
      modalRoute(
        'payment/:paymentId/repeat',
        'Home:PaymentDetails:TransferRepeat',
        () => import('@/components/wallets/modals/transfer/Transfer.vue'),
      ),
      modalRoute(
        'transfer',
        'Home:Transfer',
        () => import('@/components/wallets/modals/transfer/Transfer.vue'),
      ),
      modalRoute(
        'order-card',
        'Home:OrderCard',
        () => import('@/components/wallets/modals/order-card/OrderCard.vue'),
      ),
      modalRoute(
        'exchange',
        'Home:Exchange',
        () => import('@/components/wallets/modals/Exchange.vue'),
      ),
      modalRoute(
        'top-up',
        'Home:TopUp',
        () =>
          import('@/components/wallets/modals/top-up/parts/TopUpWallet.vue'),
      ),
      modalRoute(
        'top-up/:walletUuid',
        'Home:TopUpList',
        () => import('@/components/wallets/modals/top-up/parts/TopUpList.vue'),
      ),
      modalRoute(
        'top-up/:walletUuid/by-card',
        'Home:TopUpByCard',
        () =>
          import(
            '@/components/wallets/modals/top-up/parts/forms/TopUpFromCard.vue'
          ),
      ),
      modalRoute(
        'top-up/:walletUuid/by-open-banking',
        'Home:TopUpByOpenBanking',
        () =>
          import(
            '@/components/wallets/modals/top-up/parts/forms/TopUpFromOpenBanking.vue'
          ),
      ),
      modalRoute(
        'top-up/:walletUuid/by-apple-pay',
        'Home:TopUpByApplePay',
        () =>
          import(
            '@/components/wallets/modals/top-up/parts/forms/TopUpFromApplePay.vue'
          ),
      ),
      modalRoute(
        'top-up/:walletUuid/by-wallet',
        'Home:TopUpByWallet',
        () =>
          import(
            '@/components/wallets/modals/top-up/parts/forms/TopUpFromWallet.vue'
          ),
      ),
      modalRoute(
        'top-up/:walletUuid/bank-transfer',
        'Home:TopUpByBankTransfer',
        () => import('@/components/wallets/modals/details/WalletDetails.vue'),
      ),
      modalRoute(
        'open-banking/return/:hash',
        'Home:OpenBankingReturn',
        () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
      ),
      modalRoute(
        'open-banking/expiry/:hash',
        'Home:OpenBankingExpiry',
        () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
      ),
      modalRoute(
        'open-banking/cancel/:hash',
        'Home:OpenBankingCancel',
        () => import('@/components/wallets/modals/OpenBankingStatus.vue'),
      ),
    ],
  },
]
